module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ListHeader', {
    attrs: {
      "title": _vm.pageTitle,
      "back-route": "event.index"
    }
  }), _vm._v(" "), _c('el-card', {
    staticClass: "el-card__search_list box-card",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filtrar Listagem")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "default"
    },
    on: {
      "click": _vm.onFilterClean
    }
  }, [_vm._v("Limpar todos filtros")])], 1)]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Evento"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Evento",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.subevento),
      callback: function($$v) {
        _vm.$set(_vm.filters, "subevento", $$v)
      },
      expression: "filters.subevento"
    }
  }, _vm._l((_vm.listSubeventos), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Grande Área CNPQ"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Grande Área CNPQ",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.area_conhecimento),
      callback: function($$v) {
        _vm.$set(_vm.filters, "area_conhecimento", $$v)
      },
      expression: "filters.area_conhecimento"
    }
  }, _vm._l((_vm.listAreaConhecimento), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Curso"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Curso",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.curso),
      callback: function($$v) {
        _vm.$set(_vm.filters, "curso", $$v)
      },
      expression: "filters.curso"
    }
  }, _vm._l((_vm.listCursos), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Instituição"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Instituição",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.instituicao),
      callback: function($$v) {
        _vm.$set(_vm.filters, "instituicao", $$v)
      },
      expression: "filters.instituicao"
    }
  }, _vm._l((_vm.listInstituicoes), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Orientador"
    }
  }, [_c('el-select', {
    staticClass: "el-select-full",
    attrs: {
      "clearable": "",
      "placeholder": "Filtrar por Orientador",
      "empty-text": "Nenhum registro encontrado"
    },
    model: {
      value: (_vm.filters.orientador),
      callback: function($$v) {
        _vm.$set(_vm.filters, "orientador", $$v)
      },
      expression: "filters.orientador"
    }
  }, _vm._l((_vm.listOrientadores), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "premiacao-eventos",
      "label": "Relatório Premiação Eventos"
    }
  }, [_c('div', {
    staticClass: "responsive-table"
  }, [(_vm.activeTab === 'premiacao-eventos') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Grande Área CNPQ")]), _vm._v(" "), _c('th', [_vm._v("Curso")]), _vm._v(" "), _c('th', [_vm._v("Instituição")]), _vm._v(" "), _c('th', [_vm._v("Simpósio Temático")]), _vm._v(" "), _c('th', [_vm._v("Código do Trabalho/Título")]), _vm._v(" "), _c('th', [_vm._v("Autor/E-mail")]), _vm._v(" "), _c('th', [_vm._v("Coautores")]), _vm._v(" "), _c('th', [_vm._v("Orientador")]), _vm._v(" "), _c('th', [_vm._v("Média WEB")]), _vm._v(" "), _c('th', [_vm._v("Média InLOCO")]), _vm._v(" "), _c('th', [_vm._v("Média Geral")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.area_conhecimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.curso))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.instituicao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.simposio_tematico))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cod_trabalho) + " - " + _vm._s(item.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.autor) + " (" + _vm._s(item.email) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.coautores))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orientador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_web))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_inloco))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.media_geral))])])
  }))]) : _vm._e()])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "merito-institucional",
      "label": "Relatório Mérito Institucional"
    }
  }, [_c('div', {
    staticClass: "responsive-table"
  }, [(_vm.activeTab === 'merito-institucional') ? _c('table', {
    staticClass: "custom-table-list"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.listFiltered.length))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Evento")]), _vm._v(" "), _c('th', [_vm._v("Orientador")]), _vm._v(" "), _c('th', [_vm._v("Total Trabalhos Orientados")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listFiltered), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.subevento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.orientador))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.total))])])
  }))]) : _vm._e()])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0070962a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/reports/ReportsFinals.vue
// module id = 710
// module chunks = 2